<template>
    <v-layout>
        <v-main>
            <v-container>
                <v-card class="text-h6" style="padding: 1em !important">
                    <h2>Wissenswertes</h2><br />
                    <h3>Abgabeinfos</h3>
                    Unsere Kitten gehören für uns zu unserem Familienrudel, werden gut sozialisiert, in den Alltag
                    integriert und voller Liebe
                    aufgezogen.<br />
                    Staubsauger, Besucher und andere Katzen sind den Kitten beim Auszug nicht mehr fremd, darauf achten
                    wir.<br />
                    <br />
                    <br />
                    <h4>Futter in der Aufzucht</h4>
                    Wir füttern unsere Katzen mit hochwertigem Futter und Frischfleisch.<br />
                    Die Kitten bekommen verschiedene Sorten, sodass ihr euch als neue Dosenöffner weniger Sorgen in der
                    Sortenauswahl machen müsst.<br />
                    Aktuell füttern wir:

                    <ul style="padding-left: 1em">
                        <li>Premiere</li>
                        <li>Animonda</li>
                        <li>Granatapet</li>
                        <li>Leonardo</li>
                        <li>Mjamjam</li>
                        <li>Frischfleisch (z.B. Hühnerherzen)</li>
                    </ul>
                    Wie auch unsere erwachsenen Tiere werden unsere Kitten an "All-You-Can-Eat" (AYCE) gewöhnt.<br />
                    Mit qualitativ angemessenem Nassfutter funktioniert das sehr gut für Mensch und Tier, mit Trockenfutter
                    allerdings leider nicht.
                    <br />
                    <br />
                    <h4>Gesundheit</h4>
                    Die Kitten und Elterntiere werden regelmäßig von unserer Tierärztin untersucht, die uns mit Rat und Tat
                    beiseite steht und uns
                    super betreut.<br />
                    Vor der Abgabe bekommen die Kitten selbstverständlich alle empfohlenen Impfungen, eine Entwurmung, einen
                    Chip und werden von der Tierärztin unseres Vertrauens durchgecheckt.
                    <br />
                    <BR />
                    <h4>Abgabebedingungen</h4>
                    Für uns sind die Kitten, auch wenn sie ausziehen werden, ein Teil von uns und deshalb möchten wir für
                    alle ein liebevolles und fürsorgliches Zuhause finden!<br />
                    Damit Mensch und Tier einen optimalen Start haben lassen wir den Kitten ausreichend Zeit sich zu
                    sozialisieren und die zweite Impfung stressfrei durchzustehen.<br />
                    <u>Abhängig von der zweiten Impfe geben wir die Kitten erst ab einem Alter von 13./14. Wochen
                        ab.</u><br />
                    <u>Wir geben kein Kitten in Einzelhaltung oder ungesicherten Freigang ab.</u><br />
                    Bei Interesse erklären wir gerne, warum wir da eine Grenze ziehen.
                    <br />
                    <br />
                    <h4>Abgabepaket</h4>
                    Wir geben euch die Kitten mit einem kleinen Paket mit, sodass ihr die wichtigsten Unterlagen und
                    Grundlagen habt.<br />
                    Bei Auszug sind die Kitten:
                    <ul style="padding-left: 1em">
                        <li>zweifach geimpft;</li>
                        <li>entwurmt; und</li>
                        <li>gechippt</li>
                    </ul><br />
                    An Unterlagen bekommt ihr:
                    <ul style="padding-left: 1em">
                        <li>Impfausweis;</li>
                        <li>Stammbaum;</li>
                        <li>ein aktuelles Gesundheitsattest; und</li>
                        <li>Gesundheitsuntersuchungen der Elterntiere</li>
                    </ul><br />
                    Und dazu schnüren wir euch noch ein kleines Starterpaket mit ein paar Snacks, die die Kitten kennen und lieben, etwas Spielzeug und einen USB-Stick mit Bildern ab der Geburt.
                    <br />
                    Natürlich unterstützen wir euch auch nach Auszug!<br/>
                    Egal welche Fragen ihr habt, wir helfen euch gerne weiter und freuen uns natürlich auch über Bilder der ausgezogenen Fellnasen!
                </v-card>
            </v-container>
        </v-main>
    </v-layout>
</template>
<!--
    TODO: Sidebar mit Links zu "Artikeln" und Artikel nachladen
-->